class GlobalListeners {
  constructor() {
    this.selectors = {
      quickAdds: '[quick-add-qf]',
      productForms: `[action="${window.Shopify.routes.root}cart/add"]:not(.ctl-product-form [action="${window.Shopify.routes.root}cart/add"])`,
      openSideCart: '.openSideCart',
      closeSideCart: '.closeSideCart',
      removeButtons: '.cart .items-wrapper .item .remove-item',
      quantitySelectorPlus: '.cart .items-wrapper .item .quantity-wrapper .plus',
      quantitySelectorMinus: '.cart .items-wrapper .item .quantity-wrapper .minus',
      cartCount: '.cart-count'
    };

    this.init();
  }

  init() {
    window.log("Initializing global QF listeners");
    document.body.addEventListener('click', this.handleEvent.bind(this));
    this.productForm();
    this.cartRelated();
    this.headerSearch();
    this.mobileMenu();
    this.sideCartTabs();
  }

  handleEvent(e) {
    this.productQuickAdd(e);
    this.siteCart(e);
    this.quantityButtons(e);
    this.removeCartItem(e);
  }

  productQuickAdd(e) {
    // PRODUCT QUICK ADD
    const quickAdd = e.target.closest(this.selectors.quickAdds);
    if (quickAdd) {
      e.preventDefault();
      const quantity = parseInt(quickAdd.dataset.quantity);
      if (quickAdd.dataset.id && quantity > 0) {
        window.cart.add({ items: [{ "id": quickAdd.dataset.id, "quantity": quantity }] });
      }
    }
  }

  productForm() {
    // PRODUCT FORM LISTENER
    const productForms = document.querySelectorAll(this.selectors.productForms);
    console.log("Product forms",productForms)
    productForms.forEach(productForm => {
      productForm.addEventListener("submit", e => {
        e.preventDefault();
        const quantity = productForm.querySelector("input.quantity-selector").value;
        const id = productForm.querySelector("#product-id").value;

        // adds properties to product submission
        // adds properties to product submission
        let properties = {};
        const propertyFields = productForm.querySelectorAll('.property')

        if(propertyFields){
          propertyFields.forEach( field =>{
            const name = field.getAttribute('name')
            const value = field.value
            if(name && value){
              properties[name] = value
            }
          })
        }

        if (quantity && id) {
          window.cart.add({ items: [{ 
            "id": id,
            "quantity": quantity,
            "properties": properties
          }]
        });
        }
      });
    });
  }

  siteCart(e) {
    // SITE CART OPEN AND CLOSE
    if (!window.QF.settings.sideCart) return;
    
    const openSideCart = e.target.closest(this.selectors.openSideCart);
    if (openSideCart) {
      e.preventDefault();
      window.cart.openSideCart();
    }

    const closeSideCart = e.target.closest(this.selectors.closeSideCart);
    if (closeSideCart) {
      e.preventDefault();
      window.cart.closeSideCart();
    }
  }

  quantityButtons(e) {
    // QUANTITY PLUS CART
    const quantityPlus = e.target.closest(this.selectors.quantitySelectorPlus);
    if (quantityPlus) {
      if (quantityPlus.getAttribute("data-pending") === "true") return;
      quantityPlus.setAttribute("data-pending", true);

      const quantityElement = quantityPlus.parentNode.querySelector(".quantity span");
      const stock = quantityElement.getAttribute("data-stock");
      const variant_id = quantityElement.getAttribute("data-variant-id");
      const inv_policy = quantityElement.getAttribute("data-inventory-policy");
      if (inv_policy === "continue" || stock > 0) {
        // if in stock or continue selling when out of stock, update cart
        window.cart.add({ items: [{ "id": variant_id, "quantity": 1 }] });
      }
    }

    // QUANTITY MINUS CART
    const quantityMinus = e.target.closest(this.selectors.quantitySelectorMinus);
    if (quantityMinus) {
      if (quantityMinus.getAttribute("data-pending") === "true") return;
      quantityMinus.setAttribute("data-pending", true);

      const quantity = quantityMinus.parentNode.querySelector(".quantity span");
      const current = parseInt(quantity.innerHTML);
      const variant_id = quantity.getAttribute("data-variant-id");

      if (current > 0) {
        const updated = current - 1;
        window.cart.update({ updates: { [variant_id]: updated } });
      }
    }
  }

  removeCartItem(e) {
    // REMOVE ITEM CART
    const removeButtons = e.target.closest(this.selectors.removeButtons);
    if (removeButtons) {
      const variant_id = removeButtons.getAttribute("data-variant-id");
      window.cart.remove(variant_id);
    }
  }

  cartRelated() {
    // update side cart/cart after change
    const renderCarts = () => {
      if (window.template === "cart") {
        window.cart.reRenderCart();
      } else {
        if (window.QF.settings.ajax_open_side_cart) {
          window.cart.openSideCart();
        } else if (window.QF.settings.ajax_toast) {
          window.cart.reRenderSideCart();
        }
      }
    };
    window.addEventListener("cart_changed", renderCarts);
    window.addEventListener("item_removed", renderCarts);

    // CART COUNT
    window.addEventListener("cart_changed", e => {
      if (e.detail.cart) {
        const cartCount = document.querySelectorAll(".cart-count");
        cartCount.forEach(count => {
          count.innerHTML = e.detail.cart.item_count;
        });
      }
    });
  }

  headerSearch() {
    const body = document.getElementsByTagName('body')[0];
    const search = document.querySelector('.search-bar-container');
    const searchTrigger = document.querySelector('.mega-menu .mega-menu-controls [data-open-search]');
    

    // Check Search exists
    if (search) {
      // Open / Close Search
      window.addEventListener('click', e => {
        const target = e.target;

        if (target.hasAttribute('data-open-search')) {
          if (target.classList.contains('active')) {
            // Return if active
            return;
          } else {
            // Open if not active
            searchTrigger.classList.add('active');
            search.classList.add('active');
            body.classList.add('searchActive');
            const searchInput = document.querySelector('.search-bar-qf .search-trigger');
 
            if(searchInput){
              searchInput.focus();
            }
            
          }
        } else if (target.classList.contains('header-search') || target.getAttribute('id') === 'submit_search') {
          // Do nothing if search is clicked
          return;
        } else if (target.closest('div').classList.contains('close')) {
          // Close if clicked off
          searchTrigger.classList.remove('active');
          search.classList.remove('active');
          body.classList.remove('searchActive');
        }
      });

      // Close search with Escape Key
      window.addEventListener('keydown', e => {
        const key = e.key;

        if (key === 'Escape') {
          if (window.activeElement.classList.contains('header-search')) {
            searchTrigger.classList.remove('active');
            search.classList.remove('active');
            body.classList.remove('searchActive');
          } else {
            return;
          }
        }
      });
    }

  }

  mobileMenu() {
    const menu = document.querySelector('.mobile-menu-outer-wrapper');
    const menuTrigger = document.querySelector('#open-mobile-menu');
    const mobileTrigger = document.querySelector('.search');
    const predictiveSearch = document.querySelector('.predictive-search-container');
    const searchBar = document.querySelector('#header-search');
    const header = menu.closest('.mega-menu-outer-shopify-wrapper');


    if (menuTrigger) {
      menuTrigger.addEventListener('click', () => {
        if (menuTrigger.classList.contains('active')) {
          menu.classList.remove('active');
          header.classList.remove('mobile-menu-active');
          menuTrigger.classList.remove('active');
          predictiveSearch.classList.remove('active');
        } else {
          menu.classList.add('active');
          menuTrigger.classList.add('active');
          header.classList.add('mobile-menu-active');
        }
      });
    }
    if (mobileTrigger) {
      mobileTrigger.addEventListener('click', () => {
        
        if (mobileTrigger.classList.contains('active')) {
          menu.classList.remove('active');
          menuTrigger.classList.remove('active');
        } else {
          menu.classList.add('active');
          menuTrigger.classList.add('active');
          searchBar.focus();
        }
      });
    }

    menu.addEventListener('click', e => {
      if (e.target.classList.contains('mobile-menu-outer-wrapper') || e.target.classList.contains('openSideCart') ) {
        menu.classList.remove('active');
        menuTrigger.classList.remove('active');
      }
    });
  }

  sideCartTabs() {
    const cart_tabs = document.querySelectorAll('.cart-tab');

    cart_tabs.forEach(tab => {
      tab.addEventListener('click', (e)=> {
        tab.classList.remove('active');
        if (!e.target.closest('.cart-tab').classList.contains('active')) {
          cart_tabs.forEach(tab => {
            tab.classList.remove('active');
          })
          let tab_selected = e.target.closest('.cart-tab');
          tab_selected.classList.add('active')
          let tab_data = tab_selected.getAttribute('data-tab');
          let cart_contents = document.querySelectorAll('.cart-content');
          cart_contents.forEach(cart_content => {
            cart_content.style.display = 'none';
          })
          document.querySelector('.' + tab_data).style.display = 'flex';
          if (tab_data == 'saved-cart') {
            if(window.wishlist.needsUpdate){
              window.wishlist.initSideCartGrid();
              window.wishlist.needsUpdate = false; 
            }
          }
          if (tab_data == 'for-you') {
            var swiper = new window.swiper('.for-you-swiper', {
              slidesPerView: 2.2,
              spaceBetween: 20,
              breakpoints: {
                376: {
                  slidesPerView: 1.4,
                  spaceBetween: 30,
                }
              },
            });
          }
        }
      })
    })
  }

}

window.GlobalListeners = GlobalListeners;
